import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var Server = function () {
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("h2", { children: "Server" }), _jsx("p", { children: "Coming soon!" })] }) }));
};
